'use es6';

// react-dnd DragType contexts
export const DRAG_TYPES = {
  MODULE: 'module',
  ADD_MODULE: 'addModule',
  CUSTOM_SECTION: 'customSection'
};